<div *ngIf="!parentAuthenticated">
    <h1>Logging you in</h1>
    <div>Please wait...</div>
</div>

<div *ngIf="parentAuthenticated">
    <h1>You are now logged in</h1>
    <div>You can now close this window.</div>
</div>
